/*
 * Policy page table of contents — YETI-style sidebar navigation.
 * Shopify owns the /policies/* markup, so the TOC is built client-side
 * from the h2 headings in the policy body: anchor ids assigned, sidebar
 * injected, current section highlighted while scrolling. No headings →
 * no TOC (renders exactly as before).
 */
(function () {
  'use strict';

  var container = document.querySelector('.shopify-policy__container');
  var body = document.querySelector('.shopify-policy__body');
  if (!container || !body) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));

  // Shopify's ToS boilerplate marks sections as inline ALL-CAPS <strong>
  // rather than headings — promote those when no real h2 structure exists.
  if (headings.length < 2) {
    var promoted = [];
    body.querySelectorAll('strong').forEach(function (s) {
      var t = s.textContent.trim();
      if (t.length >= 3 && t.length <= 70 && t === t.toUpperCase() && /[A-Z]{3}/.test(t)) {
        s.classList.add('policy-heading');
        promoted.push(s);
      }
    });
    headings = promoted;
  }
  if (headings.length < 2) return;

  var nav = document.createElement('nav');
  nav.className = 'policy-toc';
  nav.setAttribute('aria-label', 'Policy sections');
  var list = document.createElement('ul');
  nav.appendChild(list);

  headings.forEach(function (h, i) {
    if (!h.id) {
      h.id = 'section-' + (i + 1) + '-' +
        h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48);
    }
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  container.classList.add('policy-layout');
  container.insertBefore(nav, container.querySelector('.shopify-policy__body'));

  // Highlight the section currently in view.
  if ('IntersectionObserver' in window) {
    var links = {};
    nav.querySelectorAll('a').forEach(function (a) {
      links[a.getAttribute('href').slice(1)] = a;
    });
    var current = null;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (current) current.classList.remove('is-current');
            current = links[entry.target.id];
            if (current) current.classList.add('is-current');
          }
        });
      },
      { rootMargin: '-15% 0px -70% 0px' }
    );
    headings.forEach(function (h) { io.observe(h); });
  }
})();
